
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#171C26","d":"M18.667 12H17.58a.833.833 0 01-.773-.533L15.473 8H7.2l-1.333 3.473a.833.833 0 01-.774.527H4v1h1.073l-.906 1.28V21h3.666v-2.667h7V21H18.5v-6.72L17.593 13h1.074v-1zM7.88 9h6.907l1.086 2.833c.022.063.048.123.08.18h-9.24c.031-.058.058-.118.08-.18L7.88 9zM6.833 20H5.167v-1.873c.257.133.543.204.833.206h.833V20zm9 0v-1.667h.834c.29-.002.575-.073.833-.206V20h-1.667zm.834-2.667H6a.833.833 0 01-.833-.833v-1.9l.88-1.247A.847.847 0 016.713 13h9.227a.847.847 0 01.667.353l.88 1.247v1.9a.833.833 0 01-.82.833zM6 14.667h2.667v1H6v-1zm8 0h2.667v1H14v-1z"}}),_c('path',{attrs:{"fill":"#000","d":"M7.473 6.693a1.844 1.844 0 00-1.862 1.796l-.806.02.002-.048a2.65 2.65 0 012.672-2.583l-.006.815zM3.424 8.412c.077-2.21 1.92-3.976 4.11-3.934l-.016.815C5.767 5.26 4.29 6.67 4.228 8.44l-.806.02.002-.048zm-1.45-.003l.002-.048c.105-3.01 2.622-5.401 5.61-5.335l-.02.815C5.018 3.783 2.87 5.824 2.78 8.39l-.806.02z"}}),_c('path',{attrs:{"fill":"#FF4F72","d":"M18.848 8.485a3.636 3.636 0 110-7.273 3.636 3.636 0 010 7.273zm.03-6.06a.455.455 0 00-.454.454V5a.455.455 0 00.91 0V2.879a.455.455 0 00-.455-.455zm-.03 4.666a.515.515 0 100-1.03.515.515 0 000 1.03z"}})])])
          )
        }
      }
    